export const MONGO_TASK_PAGE = '/second-portfolio-page/tasks'
export const ABOUT_ME ='/second-portfolio-page/about'
export const HOME_PAGE = '/second-portfolio-page'